import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import TargetAudience from '../components/TargetAudience';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import Process from '../components/Process';
import TikTokLive from '../components/TikTokLive';
import FAQ from '../components/FAQ';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { Helmet } from 'react-helmet';

const LandingPage = () => {
  const [showForm, setShowForm] = useState(false);

  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Helmet>
        <title>Creator Agentur Köln | Bad Girl's Society</title>
        <meta name="description" content="Bad Girl's Society ist eine Social Media Content & Marketing Agentur für Creator in Köln. Content-Strategie, Performance-Analyse und TikTok LIVE Management. Jetzt bewerben." />
        <meta name="keywords" content="Creator Agentur, Content Marketing Agentur, TikTok LIVE Management, Social Media Agentur Köln, Creator Management, Content Strategie, Social Media Marketing" />
        <link rel="canonical" href="https://bad-girl-society.com/" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bad-girl-society.com/" />
        <meta property="og:title" content="Creator Agentur Köln | Bad Girl's Society" />
        <meta property="og:description" content="Social Media Content & Marketing Agentur für Creator in Köln. Content-Strategie, Performance-Analyse und TikTok LIVE Management." />
        <meta property="og:site_name" content="Bad Girl's Society" />
        <meta property="og:locale" content="de_DE" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Creator Agentur Köln | Bad Girl's Society" />
        <meta name="twitter:description" content="Social Media Content & Marketing Agentur für Creator in Köln. Content-Strategie, Performance-Analyse und TikTok LIVE Management." />
      </Helmet>

      <div className="landing-page bg-black text-white min-h-screen">
        <Header onCTAClick={scrollToForm} />
        <HeroSection onCTAClick={scrollToForm} />
        <TargetAudience />
        <Services />
        <Process />
        <WhyUs />
        <TikTokLive onCTAClick={scrollToForm} />
        <FAQ />
        <ContactForm />
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;
